import React from "react";
import Marquee from "react-fast-marquee";
import { Sparkles } from "lucide-react";

const ITEMS = ["You Create. We Scale.", "Inspire · Impact · Earn", "Views to Sales in Hours", "Automate Everything"];

const MarqueeRibbon = () => {
    return (
        <div data-testid="marquee-ribbon" className="relative border-y border-neon-purple/20 bg-panel/60 py-5">
            <Marquee speed={55} gradient={false} pauseOnHover>
                {ITEMS.map((text, i) => (
                    <span key={i} className="mx-8 flex items-center gap-8">
                        <span className="font-display text-sm font-bold uppercase tracking-[0.2em] text-white/80 sm:text-base">
                            {text}
                        </span>
                        <Sparkles size={16} className="text-neon-pink" />
                    </span>
                ))}
            </Marquee>
        </div>
    );
};

export default MarqueeRibbon;
